var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ColumnBaseComponent } from '../../../../../items/columns/base/columnbase.component';
import { ColumnService } from '../../../../../items/columns/column/column.service';
import { ColumnBaseService } from '../../../../../items/columns/base/columnbase.service';
import { KtsDateTimeService, PickerOptions } from './datetime.service';
var KtsDateComponent = /** @class */ (function (_super) {
    __extends(KtsDateComponent, _super);
    function KtsDateComponent(service, baseService, datetimeService) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.datetimeService = datetimeService;
        _this.datetimeFlg = false; // controlType: datetime の時間選択で使うときtrue
        _this.defOptions = new PickerOptions();
        _this.addOptions = {};
        _this.close = true;
        _this.isMobile = false;
        _this.formatMobile = 'Y-m-d';
        _this.valMobile = '';
        _this.minDateMobile = '';
        _this.maxDateMobile = '';
        _this.isMobile = _this.datetimeService.isMobile();
        return _this;
    }
    KtsDateComponent.prototype.ngOnChanges = function (changes) {
        if (changes.msg) {
            this.defOptions = this.datetimeService.getDefOptions(this.col, this.msg);
            if (this.defOptions.minDate) {
                this.minDate = flatpickr.parseDate(this.defOptions.minDate, this.datetimeFlg ? this.defOptions.formats.format : this.defOptions.dateFormat);
            }
            if (this.defOptions.maxDate) {
                this.maxDate = flatpickr.parseDate(this.defOptions.maxDate, this.datetimeFlg ? this.defOptions.formats.format : this.defOptions.dateFormat);
            }
        }
        if (changes.col) {
            var from = jsonpath.value(this.col, '$.params.range.from');
            var to = jsonpath.value(this.col, '$.params.range.to');
            if (from && to) {
                this.fromKey = this.baseService.getColKey(this.componentName, from, this.index);
                this.toKey = this.baseService.getColKey(this.componentName, to, this.index);
            }
        }
        if (changes.val) {
            if (typeof this.val === 'undefined' || this.val === null) {
                _super.prototype.onChange.call(this, '', false);
            }
            if (this.isMobile) {
                if (this.val) {
                    this.valMobile = flatpickr.formatDate(flatpickr.parseDate(this.val, this.defOptions.dateFormat), this.formatMobile);
                }
                else {
                    this.valMobile = this.val;
                }
            }
        }
        var changeValFlg = this.changeValFlg;
        _super.prototype.ngOnChanges.call(this, changes);
        if (changeValFlg) {
            // 必須チェック(super.checkVal())の後に値をセットする
            this.setVal();
        }
    };
    KtsDateComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    KtsDateComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.element = this.dateElement.nativeElement;
        if (this.isMobile) {
            $(this.element).on('click', function () {
                var mode = (_this.colKey === _this.fromKey ? "from" /* from */ : (_this.colKey === _this.toKey ? "to" /* to */ : null));
                _this.setMinAndMaxDate(_this.fromKey, _this.toKey, mode);
                _this.minDateMobile = _this.addOptions.minDate ? flatpickr.formatDate(_this.addOptions.minDate, _this.formatMobile) : '';
                _this.maxDateMobile = _this.addOptions.maxDate ? flatpickr.formatDate(_this.addOptions.maxDate, _this.formatMobile) : '';
            });
            $(this.element).on('change', function () {
                if (_this.valMobile) {
                    var val = flatpickr.parseDate(_this.valMobile, _this.formatMobile);
                    val.setHours(0, 0, 0, 0);
                    if (_this.minDateMobile) {
                        var minDateMobile = flatpickr.parseDate(_this.minDateMobile, _this.formatMobile);
                        minDateMobile.setHours(0, 0, 0, 0);
                        if (minDateMobile.getTime() > val.getTime()) {
                            val = minDateMobile;
                        }
                    }
                    if (_this.maxDateMobile) {
                        var maxDateMobile = flatpickr.parseDate(_this.maxDateMobile, _this.formatMobile);
                        maxDateMobile.setHours(0, 0, 0, 0);
                        if (maxDateMobile.getTime() < val.getTime()) {
                            val = maxDateMobile;
                        }
                    }
                    _this.valMobile = flatpickr.formatDate(val, _this.formatMobile); // ngOnChanges()が呼ばれないことがあるのでここでセットする
                    var date = flatpickr.formatDate(val, _this.defOptions.dateFormat);
                    _super.prototype.onChange.call(_this, date);
                }
                else {
                    _super.prototype.onChange.call(_this, _this.valMobile);
                }
            });
        }
    };
    KtsDateComponent.prototype.setVal = function () {
        if (this.picker) {
            if (this.val) {
                this.picker.setDate(this.val, false, this.defOptions.dateFormat);
            }
            else {
                this.picker.clear();
            }
        }
    };
    KtsDateComponent.prototype.setDateTimePicker = function () {
        var _this = this;
        var self = this;
        if (this.fromKey && this.toKey) {
            // 開始日
            if (this.colKey === this.fromKey) {
                this.picker = flatpickr(this.element, Object.assign({}, this.defOptions, this.addOptions, {
                    onClose: function (selectedDates, dateStr, instance) {
                        self.close = true;
                    },
                    onChange: function (selectedDates, dateStr, instance) {
                        _super.prototype.onChange.call(_this, dateStr);
                    }
                }));
            }
            // 終了日
            if (this.colKey === this.toKey) {
                this.picker = flatpickr(this.element, Object.assign({}, this.defOptions, this.addOptions, {
                    onClose: function (selectedDates, dateStr, instance) {
                        self.close = true;
                    },
                    onChange: function (selectedDates, dateStr, instance) {
                        _super.prototype.onChange.call(_this, dateStr);
                    }
                }));
            }
        }
        else {
            this.picker = flatpickr(this.element, Object.assign({}, this.defOptions, this.addOptions, {
                onClose: function (selectedDates, dateStr, instance) {
                    self.close = true;
                },
                onChange: function (selectedDates, dateStr, instance) {
                    _super.prototype.onChange.call(_this, dateStr);
                }
            }));
        }
    };
    KtsDateComponent.prototype.setMinAndMaxDate = function (from, to, mode) {
        // Min
        var minDate = null;
        if (this.minDate) {
            minDate = new Date(this.minDate.getTime());
            minDate.setHours(0, 0, 0, 0);
        }
        var fromDate = null;
        if (mode === "to" /* to */) {
            fromDate = flatpickr.parseDate($('input[name="' + from + '"]').val(), this.defOptions.dateFormat);
            if (fromDate) {
                fromDate.setHours(0, 0, 0, 0);
            }
        }
        var targetMinDate = minDate;
        if ((!targetMinDate && fromDate) || (targetMinDate && fromDate && targetMinDate.getTime() < fromDate.getTime())) {
            targetMinDate = fromDate;
        }
        this.addOptions.minDate = targetMinDate;
        // Max
        var maxDate = null;
        if (this.maxDate) {
            maxDate = new Date(this.maxDate.getTime());
            maxDate.setHours(0, 0, 0, 0);
        }
        var toDate = null;
        if (mode === "from" /* from */) {
            toDate = flatpickr.parseDate($('input[name="' + to + '"]').val(), this.defOptions.dateFormat);
            if (toDate) {
                toDate.setHours(0, 0, 0, 0);
            }
        }
        var targetMaxDate = maxDate;
        if ((!targetMaxDate && toDate) || (targetMaxDate && toDate && targetMaxDate.getTime() > toDate.getTime())) {
            targetMaxDate = toDate;
        }
        this.addOptions.maxDate = targetMaxDate;
        this.addOptions.defaultDate = this.val;
    };
    KtsDateComponent.prototype.onClick = function (e) {
        if (!this.close) {
            return;
        }
        // flatpickrの数が多いと動作が遅くなるのでクリック時に生成する
        this.close = false;
        var mode = (this.colKey === this.fromKey ? "from" /* from */ : (this.colKey === this.toKey ? "to" /* to */ : null));
        this.setMinAndMaxDate(this.fromKey, this.toKey, mode);
        this.setDateTimePicker();
        this.picker.open();
    };
    KtsDateComponent.prototype.ngAfterViewChecked = function () {
        if (this.picker) {
            var cls = this.element.className;
            if (this.close && !cls.match(/active/)) {
                // flatpickrの数が多いと動作が遅くなるので日付選択後に削除する
                var val = this.val;
                this.picker.destroy();
                this.picker = null;
                // destroy()を行うと設定がクリアされてしまうので再設定する
                this.element.value = val;
                this.element.setAttribute('readonly', 'true');
                this.element.classList.add('flatpickr-input');
            }
        }
    };
    KtsDateComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        if (this.picker) {
            this.picker.destroy();
        }
    };
    KtsDateComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-column-date',
                    template: "\n        <ng-template [ngIf]=\"!isMobile\">\n            <input type=\"text\" name=\"{{ colKey }}\" attr.name=\"{{ colKey }}\" class=\"flatpickr-input\"\n                   [readOnly]=\"true\" [placeholder]=\"col\" [(ngModel)]=\"val\" [key]=\"key\" [col]=\"col\" columnDir #date\n                   (click)=\"onClick($event)\">\n        </ng-template>\n        <ng-template [ngIf]=\"isMobile\">\n            <input type=\"date\" name=\"{{ colKey }}\" attr.name=\"{{ colKey }}\" [min]=\"minDateMobile\" [max]=\"maxDateMobile\"\n                   [placeholder]=\"col\" [(ngModel)]=\"valMobile\" [key]=\"key\" [col]=\"col\" columnDir #date>\n        </ng-template>\n    "
                }] }
    ];
    /** @nocollapse */
    KtsDateComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService },
        { type: KtsDateTimeService }
    ]; };
    KtsDateComponent.propDecorators = {
        datetimeFlg: [{ type: Input }],
        dateElement: [{ type: ViewChild, args: ['date',] }]
    };
    return KtsDateComponent;
}(ColumnBaseComponent));
export { KtsDateComponent };
//# sourceMappingURL=date.component.js.map